import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { ClientOnly } from "@/utils/client-only";

import {
    GlobalFooterBottom,
    GlobalFooterBottomFallback
} from "./global-footer-bottom";
import { GlobalFooterTop } from "./global-footer-top";

const globalFooterStyle = css({
    alignItems: "center",
    background: "#ffffff",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
});

const globalFooterContentContainerStyle = css({
    backgroundColor: "#fff",
    paddingBlock: token("space.200"),
    display: "flex",
    flexDirection: "column",
    gap: token("space.200"),
    width: "100%",
    marginInline: "24px",

    [media.above.md]: {
        display: "flex",
        maxWidth: "1200px",
        paddingInline: "0",
        marginInline: "60px"
    }
});

export type GlobalFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

export const GlobalFooterFallback = () => (
    <footer css={globalFooterStyle}>
        <div css={globalFooterContentContainerStyle}>
            <GlobalFooterTop />
            <GlobalFooterBottomFallback />
        </div>
    </footer>
);

export const GlobalFooterSync = ({
    selectedLanguage,
    onLanguageChangeHandler
}: GlobalFooterPatternProps) => (
    <ClientOnly>
        <UFOSegment name="global-footer-v2">
            <footer css={globalFooterStyle}>
                <div css={globalFooterContentContainerStyle}>
                    <GlobalFooterTop />
                    <GlobalFooterBottom
                        selectedLanguage={selectedLanguage}
                        onLanguageChangeHandler={onLanguageChangeHandler}
                    />
                </div>
            </footer>
        </UFOSegment>
    </ClientOnly>
);
